import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Ng2PaginationModule} from 'ng2-pagination';
import {PaginationBootstrapModule} from 'shared/pagination-bootstrap/pagination-bootstrap.module';

import {ManagementLevelRoutingModule} from './management-level-routing.module';

import {ModalConfirmationModule} from 'shared/modals/modal-confirmation/modal-confirmation.module';
import {SearchBarModule} from 'shared/search-bar/search-bar.module';
import {ManagementLevelComponent} from './management-level.component';
import {ManagementLevelRepository} from './repositories/management-level.repository';
import {ManagementLevelService} from './services/management-level.service';

@NgModule({
  imports: [
    CommonModule,
    ManagementLevelRoutingModule,
    SearchBarModule,
    FormsModule,
    Ng2PaginationModule,
    PaginationBootstrapModule,
    ModalConfirmationModule,
  ],
  declarations: [
    ManagementLevelComponent,
  ],
  providers: [
    ManagementLevelService,
    ManagementLevelRepository,
  ],
})

export class ManagementLevelModule {}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/management-level/management-level.module.ts